import { useEffect, useState } from "react";

const KEYWORDS = [
  // Primary services (biggest)
  { t: "Pet Transport UK to Europe", size: 44, w: 700 },
  { t: "Pet Taxi Paris", size: 36, w: 600 },
  { t: "Eurotunnel Pet Travel", size: 32, w: 500 },
  { t: "Pet Chauffeur UK to France", size: 32, w: 600 },
  // Mid tier
  { t: "Dog Taxi Calais", size: 20, w: 500 },
  { t: "Cat Transport UK to Europe", size: 20, w: 500 },
  { t: "London to Paris Pet Transport", size: 22, w: 500 },
  { t: "Folkestone to Calais Pet Taxi", size: 22, w: 500 },
  { t: "Charles de Gaulle Airport", size: 20, w: 500 },
  { t: "Amsterdam Schiphol", size: 18, w: 500 },
  { t: "Brussels Zaventem", size: 18, w: 500 },
  { t: "Professional Pet Courier UK", size: 20, w: 500 },
  { t: "DEFRA Approved Pet Transporter", size: 18, w: 500 },
  { t: "Cheapest Pet Taxi UK", size: 18, w: 500 },
  { t: "Door-to-Door Pet Transport", size: 20, w: 500 },
  // Routes
  { t: "London → Paris", size: 16, w: 400 },
  { t: "London → Amsterdam", size: 16, w: 400 },
  { t: "London → Brussels", size: 16, w: 400 },
  { t: "London → Frankfurt", size: 16, w: 400 },
  { t: "London → Madrid", size: 16, w: 400 },
  { t: "London → Barcelona", size: 16, w: 400 },
  { t: "London → Berlin", size: 16, w: 400 },
  { t: "London → Rome", size: 16, w: 400 },
  { t: "Paris → London", size: 16, w: 400 },
  { t: "Amsterdam → London", size: 16, w: 400 },
  { t: "Brussels → London", size: 16, w: 400 },
  { t: "Calais → Folkestone", size: 16, w: 400 },
  { t: "Folkestone → Calais", size: 16, w: 400 },
  { t: "CDG → London", size: 16, w: 400 },
  { t: "Schiphol → London", size: 16, w: 400 },
  // Service tags
  { t: "pet travel paris", size: 13, w: 300 },
  { t: "dog taxi france", size: 13, w: 300 },
  { t: "cat shipping uk", size: 13, w: 300 },
  { t: "pet courier europe", size: 13, w: 300 },
  { t: "pet passport uk", size: 13, w: 300 },
  { t: "pet relocation uk to france", size: 13, w: 300 },
  { t: "pet transport spain", size: 13, w: 300 },
  { t: "pet transport portugal", size: 13, w: 300 },
  { t: "pet transport germany", size: 13, w: 300 },
  { t: "pet transport belgium", size: 13, w: 300 },
  { t: "pet transport netherlands", size: 13, w: 300 },
  { t: "pet transport italy", size: 13, w: 300 },
  { t: "pet chauffeur london", size: 13, w: 300 },
  { t: "pet transport birmingham", size: 13, w: 300 },
  { t: "pet transport manchester", size: 13, w: 300 },
  { t: "pet transport edinburgh", size: 13, w: 300 },
  { t: "pet transport glasgow", size: 13, w: 300 },
  { t: "pet transport bristol", size: 13, w: 300 },
  { t: "pet transport leeds", size: 13, w: 300 },
  { t: "ferret transport uk", size: 13, w: 300 },
  { t: "animal passport europe", size: 13, w: 300 },
  { t: "eurotunnel leshuttle pet", size: 13, w: 300 },
  { t: "pet travel without flying", size: 13, w: 300 },
  { t: "pet friendly chauffeur", size: 13, w: 300 },
  { t: "instant pet transport quote", size: 13, w: 300 },
  { t: "under 60 seconds price", size: 13, w: 300 },
  { t: "pet taxi near me", size: 13, w: 300 },
  { t: "dog transport cross-channel", size: 13, w: 300 },
  { t: "cat transport cross-channel", size: 13, w: 300 },
  { t: "no cages — pet travels with you", size: 13, w: 300 },
];

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    // Show on first load per session only
    if (typeof window === "undefined") return false;
    try { return !sessionStorage.getItem("splash_seen"); } catch { return true; }
  });

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      try { sessionStorage.setItem("splash_seen", "1"); } catch {}
      setVisible(false);
    }, 1800);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center animate-splash-fade"
      style={{ background: "#0A1310" }}
      data-testid="splash-screen"
      aria-hidden="true"
    >
      {/* Keyword wall */}
      <div className="relative flex-1 w-full max-w-5xl flex items-center justify-center overflow-hidden">
        <div className="flex flex-wrap gap-x-4 gap-y-2 items-center justify-center px-6 opacity-55 max-h-[55vh] overflow-hidden">
          {KEYWORDS.map((k, i) => (
            <span
              key={i}
              style={{
                fontSize: `${k.size}px`,
                fontWeight: k.w,
                color: i % 7 === 0 ? "#A3B18A" : i % 11 === 0 ? "#D4C196" : "#5A6B5E",
                lineHeight: 1.1,
                letterSpacing: k.size > 24 ? "-0.02em" : "0",
              }}
            >
              {k.t}
            </span>
          ))}
        </div>
      </div>

      {/* Brand lockup */}
      <div className="pb-16 text-center">
        <h1
          className="font-display tracking-tight"
          style={{ fontSize: "clamp(48px, 8vw, 96px)", color: "#F3E9CF", lineHeight: 1 }}
        >
          UK<span style={{ color: "#D4C196" }}> PET </span>TRANSPORT
        </h1>
        <p
          className="mt-5 uppercase"
          style={{ color: "#A3B18A", fontSize: "13px", letterSpacing: "0.3em" }}
        >
          Premium Pet Transport via Eurotunnel
        </p>
      </div>

      <style>{`
        @keyframes splash-fade-out {
          0%, 70% { opacity: 1; }
          100% { opacity: 0; visibility: hidden; }
        }
        .animate-splash-fade {
          animation: splash-fade-out 1800ms ease-in-out forwards;
        }
      `}</style>
    </div>
  );
}
